import React, {useState} from 'react'
//import redux
import { useSelector, useDispatch } from 'react-redux';

//swiper slideshow for add on packages popups
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs } from "swiper";

//popup component
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import PopupBtnClose from '../../../../../img/popup-close-button.svg';
import { toggleIndex } from '../redux/addOnPopupToggles/addOnPopupTogglesSlice';

/**
 * Functional component representing a course add on popup
 * @param {Object} courseAddOn - Object representing a course Add On
 */
function CourseAddOnPopup({courseAddOn}) {
    const popupToggles = useSelector((state) => state.addOnPopupToggles.value);
    const dispatch = useDispatch();

    // Item record id of the course add on
    const recordId = courseAddOn.record_id;

    const thisPopupToggle = popupToggles?.[recordId] ? popupToggles?.[recordId] : false;

    const [thumbsSwiper, setThumbsSwiper] = useState(null)

    // when the popup closes we need to remove un set the thumb swiper
    const closeHandler = () => {
        setThumbsSwiper(null)
        dispatch(toggleIndex(recordId));
    }

    // Component level JSX return statement ******************************************************
    return (
        // Course Add On Popup
        // opens on toggle state by item record id index
        <Popup className="rct-popup" open={thisPopupToggle} position="center center" modal onClose={closeHandler}>
            {close => (
            <div>
                <a className="rct-popup-content__close" onClick={close}><PopupBtnClose /></a>
                <h2 className="border-headline">{courseAddOn.title}</h2>
                {/* if we have pop up galler show the main image */}
                {courseAddOn.popup.gallery &&
                <Swiper
                    spaceBetween={10}
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[Thumbs]}
                    className="simple-swiper">
                        {courseAddOn.popup.gallery.map((galleryItem) => {
                            return(
                                <SwiperSlide><img src={galleryItem.sizes["image-card"]} width="434px" height="250px" /></SwiperSlide>
                            )
                        })}
                </Swiper>
                }
                {/* if we have multiple images show the thumb slider */}
                {courseAddOn.popup.gallery.length > 1 &&
                <Swiper
                    onSwiper={setThumbsSwiper}
                    watchSlidesProgress
                    spaceBetween={13}
                    slidesPerView={4}
                    modules={[Thumbs]}
                    className="simple-swiper-thumbs">
                        {courseAddOn.popup.gallery.map((galleryItem) => {
                            return(
                                <SwiperSlide><img src={galleryItem.sizes["image-card"]} width="98px" height="56px" /></SwiperSlide>
                            )
                        })}
                </Swiper>
                }
                <div className="rtecontent" dangerouslySetInnerHTML={{__html: courseAddOn.popup.description}}/>
            </div>
            )}
        </Popup>
    )
}
export default CourseAddOnPopup;